import { ChartData } from 'chart.js';
import Chart from 'src/stores/application/classes/Chart';
import { Unit } from 'src/stores/application/unit';
import { SortedUnitSensor } from '../../../shared/SortedUnitSensorData';

export interface ProcessedChartData  {
    data: ChartData;
    sortedUnitSensor: SortedUnitSensor[];
}
export interface EachGeoChartDataResult extends ChartData {
    unit: Unit;
}

export type ChartDataResult = EachGeoChartDataResult[] | ProcessedChartData;

interface SharedSharedChartRenderProps {
    height: number;
    width: number;
    redraw: boolean;
    CurrentChart: Chart;
    [index: string]: any;
}

export interface SharedChartRenderProps extends SharedSharedChartRenderProps {
    data: ChartData;
}

export interface ComputedChartRenderProps extends SharedSharedChartRenderProps {
    data: ChartDataResult;
}

export function getOptions(currentChart: Chart, additionalOption?: any) {
    return {
        animation: {
            duration: 0.89
        },
        legend: {
            display: true
        },
        tooltips: {
            callbacks: {
                label: (item: any) => `${item.yLabel} ${currentChart.measurementUnit}`,
            },
        },
        title: {
            display: true,
            text: currentChart.name
        },
        
        ...additionalOption
    };
}



// WEBPACK FOOTER //
// ./src/container/Chart/renders/Shared.ts